/**
 * Prefer embedded product JSON on PDPs so variant IDs always match the form.
 * Also falls back when /products/{handle}.js 404s (draft / preview).
 */
(function () {
  function getEmbeddedProduct(url) {
    var nodes = document.querySelectorAll("script[data-product-json]");
    var i;
    var product;

    for (i = 0; i < nodes.length; i += 1) {
      try {
        product = JSON.parse(nodes[i].textContent);
      } catch (err) {
        product = null;
      }

      if (!product || !product.handle) {
        continue;
      }

      if (!url || String(url).indexOf("/products/" + product.handle) !== -1) {
        return product;
      }
    }

    if (nodes.length && url && /\/products\/[^/?#]+\.js/.test(String(url))) {
      try {
        return JSON.parse(nodes[0].textContent);
      } catch (err) {
        return null;
      }
    }

    return null;
  }

  var originalFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : input && input.url;

    if (url && /\/products\/[^/?#]+\.js/.test(String(url))) {
      var embeddedFirst = getEmbeddedProduct(String(url));
      if (embeddedFirst) {
        return Promise.resolve(
          new Response(JSON.stringify(embeddedFirst), {
            status: 200,
            headers: { "Content-Type": "application/json" },
          })
        );
      }
    }

    return originalFetch(input, init)
      .then(function (response) {
        if (
          response &&
          !response.ok &&
          url &&
          /\/products\/[^/?#]+\.js/.test(String(url))
        ) {
          var embedded = getEmbeddedProduct(String(url));
          if (embedded) {
            return new Response(JSON.stringify(embedded), {
              status: 200,
              headers: { "Content-Type": "application/json" },
            });
          }
        }
        return response;
      })
      .catch(function (err) {
        var embedded = url && getEmbeddedProduct(String(url));
        if (embedded) {
          return new Response(JSON.stringify(embedded), {
            status: 200,
            headers: { "Content-Type": "application/json" },
          });
        }
        throw err;
      });
  };
})();
